// ============================================================
// FILE: CreditsPage.js
// LOCATION: C:\gardenmarket\web\src\pages\gardener\CreditsPage.js
// ============================================================
import { Link } from 'react-router-dom';
import CreditBalance from '../../components/CreditBalance';
import CreditLedger  from '../../components/CreditLedger';
import MyReferrals   from '../../components/MyReferrals';
import { colors } from '../../theme/theme';

export default function CreditsPage() {
    return (
        <div style={{ maxWidth:'700px', margin:'0 auto', padding:'32px 24px' }}>
            <div style={{ marginBottom:'16px' }}>
                <Link to="/gardener/dashboard" style={{ color:colors.brand, fontSize:'0.9rem' }}>
                    ← Back to Dashboard
                </Link>
            </div>
            <h1 style={{ color:colors.brand, marginBottom:'24px' }}>My Credits</h1>
            <CreditBalance />
            {/* Referrals sit between the balance and the ledger:
                it is the one way to top up without paying, so it
                belongs next to the balance rather than buried
                under the statement. Renders nothing until the
                gardener has a referral code. */}
            <MyReferrals />
            <CreditLedger />
        </div>
    );
}
